/**
 * AddActionsMenuItem Handler для Table
 * 
 * Додає меню дій до кожного рядка таблиці
 */

import React from 'react'
import { Dropdown } from 'antd'
import { SvgInline } from '@/Core/Components/SvgInline'
import MenuDotsIcon from './menu-dots.svg?react'

/**
 * Додає меню дій до рядка таблиці
 * 
 * @param params - об'єкт з параметрами
 * @param params.item - елемент dataSource
 * @param params.tableContext - контекст таблиці
 */
export const AddActionsMenuItem = ({ item, tableContext }: { item: any, tableContext: any }) => {
    
    const crudContext = tableContext.storages?.crudContext
    
    if (crudContext?.settings?.tableIsActionsColumnHide === true) return
    
    const transformerStorage =
        crudContext?.storages?.tableAddActionsMenuDataSourceItemTransformer ??
        tableContext.storages?.tableAddActionsMenuDataSourceItemTransformer ??
        {}

    let menuItems: any[] = []

    if (typeof transformerStorage?.menuItems === 'function') {
        menuItems = transformerStorage.menuItems({ item, tableContext })
    } else if (transformerStorage?.menuItems) {
        menuItems = transformerStorage.menuItems
    }

    tableContext.eventManager?.run?.('onMenuItemsBuild', { menuItems, item, tableContext, crudContext })
    
    item['_actions'] =
        Array.isArray(menuItems) && menuItems.length > 0
            ? React.createElement(Dropdown, {
                menu: { items: menuItems },
                trigger: ['click'],
                ...(transformerStorage?.dropdownProps ?? {}),
                children: React.createElement(
                    'a',
                    {
                        onClick: (e: any) => e.preventDefault(),
                        style: { cursor: 'pointer', color: 'var(--ant-color-primary, #e84923)' },
                    },
                    transformerStorage?.menuIcon ??
                        React.createElement(SvgInline, { component: MenuDotsIcon, className: 'wl-menu-trigger-icon' })
                ),
            })
            : null
}
